<template>
    <div class="calendar--step-range">
        <span class="step-range__label pointer"
              @click="setStepGlobal(defaultSteps[stepRange - 1])">-</span>
        <b-form-input :value="stepRange" @change="changeEvent" type="range" min="0" max="4"></b-form-input>
        <span class="step-range__label pointer"
              @click="setStepGlobal(defaultSteps[stepRange + 1])">+</span>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: "StepSlider",
    props: {
        value: null
    },
    mounted() {
    },
    data() {
        return {
            defaultSteps: [5, 15, 30, 45, 60],
            pendingPromise: null
        }
    },
    watch: {},
    computed: {
        ...mapState('users', { isPatchPending: 'isPatchPending' }),
        ...mapState('auth', { currentUser: 'user' }),

        step() {
            return this.settings.calendarStep
        },

        stepRange() {
            return this.defaultSteps.findIndex(el => el === this.step)
        },

        settings: {
            get() {
                let settings = {
                    HideCalendarPrevious: true,
                    CalendarCurrent: {
                        value: '3days', label: '3 Days', option: { value: 3, type: 'days' }
                    },
                    calendarStep: this.$settings.step
                }
                if (this.currentUser.settings)
                    settings = { ...settings, ...this.currentUser.settings }

                if (this.isMobile)
                    settings = {
                        HideCalendarPrevious: true,
                        CalendarCurrent: {
                            value: 'day', label: 'Day', option: { value: 1, type: 'day' }
                        }
                    }
                return settings;
            }
        }
    },

    methods: {
        ...mapActions('profile', { updateUser: 'patch' }),

        changeEvent(value) {
            this.setStepGlobal(this.defaultSteps[value]);
        },

        saveUser() {
            this.$emit('input', true)
            return this.updateUser(['me', { settings: this.settings }, {}]).finally(() => {
                this.$emit('input', false)
                this.$emit('change', false)
            });
        },

        async setStepGlobal(step) {
            if (!step)
                return;
            if (this.pendingPromise)
                await this.pendingPromise
            this.$settings.step = step;
            this.settings.calendarStep = step;
            this.pendingPromise = this.saveUser();
        }
    }
}
</script>

<style lang="scss" scoped>
.calendar {
    &--step-range {
        position: relative;
        display: flex;
        padding: 2px 5px 0;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 0.375rem;
        background-color: #fffdfd;

        .custom-range {
            display: inline-block;
            margin: 0 5px;
        }

        .custom-range::-webkit-slider-thumb {
            height: 14px;
            width: 14px;
        }

        .step-range {
            &__label {
                font-size: 12px;
            }
        }
    }
}

</style>
